import { Instagram } from "lucide-react";
import { useContent } from "@/lib/content";

export const Footer = () => {
  const { footer } = useContent();
  return (
  <footer className="border-t border-champagne bg-ivory" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 md:px-12 py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
      <div>
        <p className="font-serif text-2xl font-semibold text-burgundy" data-testid="footer-name">{footer.name}</p>
        <p className="mt-2 text-[11px] uppercase tracking-[0.3em] text-charcoal/50" data-testid="footer-tagline">
          {footer.tagline}
        </p>
      </div>
      <div className="flex items-center gap-8">
        <a
          href={footer.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.25em] text-charcoal/70 hover:text-burgundy transition-colors duration-300"
        >
          <Instagram size={16} strokeWidth={1.5} />
          {footer.instagramLabel}
        </a>
        <span className="text-[11px] uppercase tracking-[0.25em] text-charcoal/40">
          © {new Date().getFullYear()} {footer.name}
        </span>
      </div>
    </div>
  </footer>
  );
};
